// Utility functions for cooking components

export const ensureArray = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
};

export const categories = [
    { name: 'Breakfast', key: 'breakfast', icon: '', color: '#FF9800' },
    { name: 'Main Course', key: 'mainCourse', apiKey: 'main course', icon: '', color: '#4CAF50' },
    { name: 'Dessert', key: 'dessert', icon: '', color: '#E91E63' },
    { name: 'Appetizer', key: 'appetizer', icon: '', color: '#9C27B0' },
    { name: 'Salad', key: 'salad', icon: '', color: '#8BC34A' },
    { name: 'Soup', key: 'soup', icon: '', color: '#FF5722' }
];

export const mealTypes = [
    { label: 'Breakfast', value: 'breakfast' },
    { label: 'Main Course', value: 'main course' },
    { label: 'Side Dish', value: 'side dish' },
    { label: 'Salad', value: 'salad' },
    { label: 'Appetizer', value: 'appetizer' },
    { label: 'Soup', value: 'soup' },
    { label: 'Dessert', value: 'dessert' },
    { label: 'Snack', value: 'snack' },
    { label: 'Drink', value: 'drink' }
];

export const dietTypes = [
    { label: 'No Restrictions', value: null },
    { label: 'Vegetarian', value: 'vegetarian' },
    { label: 'Vegan', value: 'vegan' },
    { label: 'Gluten Free', value: 'gluten free' },
    { label: 'Ketogenic', value: 'ketogenic' },
    { label: 'Paleo', value: 'paleo' }
];

export const intoleranceOptions = [
    { label: 'Dairy', value: 'dairy' },
    { label: 'Egg', value: 'egg' },
    { label: 'Gluten', value: 'gluten' },
    { label: 'Grain', value: 'grain' },
    { label: 'Peanut', value: 'peanut' },
    { label: 'Seafood', value: 'seafood' },
    { label: 'Sesame', value: 'sesame' },
    { label: 'Shellfish', value: 'shellfish' },
    { label: 'Soy', value: 'soy' },
    { label: 'Sulfite', value: 'sulfite' },
    { label: 'Tree Nut', value: 'tree nut' },
    { label: 'Wheat', value: 'wheat' }
]; 